import enSharedCommon from 'locales/en/shared/common.yml'
import enSharedOther from 'locales/en/shared/other.yml'
import enSharedPaymentPeriod from 'locales/en/shared/payment_period.yml'
import enSharedPaymentForm from 'locales/en/shared/payment_form.yml'
import enSharedPaymentState from 'locales/en/shared/payment_state.yml'
import enSharedInvoiceForm from 'locales/en/shared/invoice_form.yml'
import enSharedProductForm from 'locales/en/shared/product_form.yml'

I18n.translations.en = I18n.extend((I18n.translations.en || {}), {
  shared: {
    common: enSharedCommon,
    other: enSharedOther,
    payment_period: enSharedPaymentPeriod,
    payment_form: enSharedPaymentForm,
    payment_state: enSharedPaymentState,
    invoice_form: enSharedInvoiceForm,
    product_form: enSharedProductForm
  }
})
